import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { lighten } from 'polished';

const Label = styled.label`
  color: ${p => p.theme.colors.lightFont};
  cursor: pointer;
  display: block;
  font-size: 1rem;
  font-weight: 500;
  line-height: 1;
  letter-spacing: 0.2px;
  padding: 5px 0 5px 25px;
  position: relative;

  &:hover > .checkmark {
    background: ${p => lighten(0.4, p.theme.colors.primary)};
  }
`;

const LabelText = styled.span``;

const Input = styled.input`
  cursor: pointer;
  position: absolute;
  opacity: 0;
`;

const CheckMark = styled.div`
  background: ${p =>
    p.checked ? lighten(0.4, p.theme.colors.primary) : p.theme.colors.lightBg};
  border: ${p => (p.error ? '1px solid red' : 'none')};
  cursor: pointer;
  display: block;
  height: 18px;
  width: 18px;
  position: absolute;
  top: 3px;
  left: 0;

  &:after {
    border: solid ${p => p.theme.colors.primary};
    border-width: 0 2px 2px 0;
    content: '';
    display: ${p => (p.checked ? 'block' : 'none')};
    height: 14px;
    position: absolute;
    left: 5px;
    top: 0;
    transform: rotate(45deg);
    width: 8px;
  }
`;

const ErrorMessage = styled.div`
  color: ${p => p.theme.colors.error};
  font-size: 0.875rem;
  margin-top: 10px;
`;

export default function Checkbox({
  name,
  label,
  value,
  checked,
  error,
  touched,
  onChange,
  onBlur,
  ...rest
}) {
  return (
    <Label>
      <Input
        {...rest}
        type="checkbox"
        name={name}
        value={value}
        checked={checked}
        onChange={onChange}
        onBlur={onBlur}
      />

      <CheckMark
        className="checkmark"
        checked={checked}
        error={touched && error}
      />

      <LabelText>{label}</LabelText>

      {touched && error && <ErrorMessage>{error}</ErrorMessage>}
    </Label>
  );
}

Checkbox.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.bool
  ]).isRequired,
  checked: PropTypes.bool.isRequired,
  error: PropTypes.string,
  touched: PropTypes.bool,
  onChange: PropTypes.func,
  onBlur: PropTypes.func
};

Checkbox.defaultProps = {
  error: '',
  touched: false,
  onChange: () => {},
  onBlur: () => {}
};
